import { render } from "./Cronometro.vue?vue&type=template&id=5cdd90cd&scoped=true"
import script from "./Cronometro.vue?vue&type=script&lang=ts"
export * from "./Cronometro.vue?vue&type=script&lang=ts"

import "./Cronometro.vue?vue&type=style&index=0&id=5cdd90cd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cdd90cd"

export default script